import { Table, TableRowProps } from "@oysterhr/ui"
import { forwardRef, useMemo } from "react"
import { useIntegratedTableController } from "./IntegratedTableControllerContext"

export interface IntegratedTableRowProps extends TableRowProps {
  dataEntry?: { id: string }
}

export const IntegratedTableRow = forwardRef<HTMLTableRowElement, IntegratedTableRowProps>(
  ({ dataEntry, ...props }, ref) => {
    const { isSelected, onToggleRow } = useIntegratedTableController()
    const rowController = useMemo(() => {
      if (!dataEntry)
        return {
          onSelectRow: undefined,
          isSelected: false,
        }

      return {
        onSelectRow: () => onToggleRow(dataEntry),
        isSelected: isSelected(dataEntry),
      }
    }, [dataEntry, isSelected, onToggleRow])
    return <Table.Row ref={ref} {...rowController} {...props} />
  },
)

IntegratedTableRow.displayName = "IntegratedTable.Row"
